{
  "version": 1,
  "asset_id": "8df5b3c0-bfe3-4509-83ea-35e39b4c5261",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/8df5b3c0-bfe3-4509-83ea-35e39b4c5261/3d-tour-placeholder.png",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/8df5b3c0-bfe3-4509-83ea-35e39b4c5261/3d-tour-placeholder.png",
  "original_filename": "3d-tour-placeholder.png",
  "size": 264952,
  "content_type": "image/png",
  "created_at": "2026-09-06T14:58:45Z"
}
